<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">美国EB-5投资移民</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>EB-5是美国职业移民第五类优先类别的简称，由美国国会于1990年创立，目的是吸引海外投资移民来美国投资及创造就业机会，此类签证每年有10000个名额。
        EB-5对申请人的要求相当宽松，没有商业背景、年龄、教育程度及语言能力的限制。一人申请，全家（配偶及21岁以下未婚子女）均可同时获得绿卡。申请成功后可自由选择美国任何城市居住，或继续留在中国工作和生活。
      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/us/5.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <p >1、申请人须投资90万美元于区域中心内的投资项目，到期后返还</p>
            <p>2、合理解释投资款来源</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/us/7.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、对申请人无学历、语言、年龄要求，其配偶及未满21岁的未婚子女可一同申请（由于排期的产生，可携带子女的年龄视排期而定）</p>
            <p>2、对申请人不要求具备任何商业背景</p>
            <p>3、对申请人无资产要求，只需证明投资金额为合法所得</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/us/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1、准备文件，交由美国律师审核</p>
            <p>2、汇出投资款</p>
            <p>3、提交I-526申请</p>
            <p>4、I-526核准</p>
            <p>5、等待排期，递交NVC</p>
            <p>6、广领馆面试，获得移民签证</p>
            <p>7、登陆美国，获得2年期临时绿卡</p>
            <p>8、提交I-829解除条件申请</p>
            <p>9、I-829核准，获得永久绿卡</p>
            <p>10、投资期满申请返还投资款</p>

          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
export default {
  name: 'UsaEb5'
}
</script>

<style scoped>

</style>
